export type OtaStatusLevel = 'info' | 'success' | 'warning' | 'error';

export type OtaStatus = {
  level: OtaStatusLevel;
  message: string;
};

export type OtaProgress = {
  percent: number;
  bytesSent: number;
  totalBytes: number;
  speedKbps: number;
  sectorIndex: number;
};

export type OtaLogEntry = {
  level: OtaStatusLevel;
  message: string;
};

export type OtaSessionOptions = {
  onStatus?: (status: OtaStatus) => void;
  onProgress?: (progress: OtaProgress) => void;
  onLog?: (entry: OtaLogEntry) => void;
  onComplete?: () => void;
  ackTimeoutMs?: number;
  maxRetries?: number;
};

export type OtaUpdateResult = {
  durationMs: number;
  bytesSent: number;
};

export class OtaAbortError extends Error {
  constructor(message = 'OTA update aborted.') {
    super(message);
    this.name = 'OtaAbortError';
  }
}
